import { getVoiceApiOrigin } from "./voiceLiveDemoLogic";
import type { TranscriptTurn } from "./voiceLiveDemoLogic";

export interface CsrAssistEnquiry {
  id: string;
  question: string;
  answer: string;
  kind?: "form" | "customer";
  status: "loading" | "ready" | "error";
}

export interface CsrAssistApiResponse {
  enquiries: Array<{
    id: string;
    question: string;
    answer: string;
  }>;
}

export async function fetchCsrAssistAnswers(
  transcript: TranscriptTurn[],
  questions: string[],
  activeFormId?: string | null
): Promise<CsrAssistApiResponse> {
  const apiOrigin = getVoiceApiOrigin();
  const response = await fetch(`${apiOrigin}/api/csr-assist`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      transcript: transcript.map((turn) => ({
        speaker: turn.speaker,
        text: turn.text,
      })),
      questions,
      activeFormId: activeFormId ?? null,
    }),
  });

  if (!response.ok) {
    let detail = `CSR assist failed (${response.status})`;
    try {
      const body = await response.json();
      if (typeof body?.detail === "string") detail = body.detail;
      else if (typeof body?.message === "string") detail = body.message;
    } catch {
      const text = await response.text();
      if (text) detail = text;
    }
    throw new Error(detail);
  }

  return response.json();
}
